import React from 'react';
import { CheckCircle, MessageSquare, TrendingUp, ShoppingBag, Truck, GraduationCap } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

const Services = ({ t }) => {
  return (
    <section id="services" className="py-20 px-4 bg-navy-50">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-navy-900 mb-4">{t.services.title}</h2>
          <p className="text-lg text-gray-700">{t.services.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {[
            { key: 'team', icon: MessageSquare },
            { key: 'shareholder', icon: TrendingUp },
            { key: 'client', icon: ShoppingBag }
          ].map(({ key, icon: Icon }) => {
            const service = t.services[key];
            return (
              <Card key={key} className="bg-white border-navy-100 hover:shadow-xl transition-all hover:-translate-y-1">
                <CardHeader>
                  <div className="w-14 h-14 bg-navy-600 rounded-lg flex items-center justify-center mb-4">
                    <Icon className="h-7 w-7 text-white" />
                  </div>
                  <CardTitle className="text-navy-900 text-xl">{service.title}</CardTitle>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2">
                    {service.features.map((feature) => (
                      <li key={feature} className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="h-5 w-5 text-navy-600 flex-shrink-0 mt-0.5" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Second row - Supplier and Training services */}
        <div className="mt-8 grid md:grid-cols-2 gap-8">
          <Card className="bg-white border-navy-100 hover:shadow-xl transition-all hover:-translate-y-1">
            <CardHeader>
              <div className="w-14 h-14 bg-navy-600 rounded-lg flex items-center justify-center mb-4">
                <Truck className="h-7 w-7 text-white" />
              </div>
              <CardTitle className="text-navy-900 text-xl">{t.services.supplier.title}</CardTitle>
              <CardDescription className="text-gray-600 leading-relaxed">
                {t.services.supplier.description}
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2">
                {t.services.supplier.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2 text-gray-700">
                    <CheckCircle className="h-5 w-5 text-navy-600 flex-shrink-0 mt-0.5" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>

          <Card className="bg-white border-navy-100 hover:shadow-xl transition-all hover:-translate-y-1">
            <CardHeader>
              <div className="w-14 h-14 bg-navy-600 rounded-lg flex items-center justify-center mb-4">
                <GraduationCap className="h-7 w-7 text-white" />
              </div>
              <CardTitle className="text-navy-900 text-xl">{t.services.training.title}</CardTitle>
              <CardDescription className="text-gray-600 leading-relaxed">
                {t.services.training.description}
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2">
                {t.services.training.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2 text-gray-700">
                    <CheckCircle className="h-5 w-5 text-navy-600 flex-shrink-0 mt-0.5" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Services;